class WalletRequest {
  static balanceEnquiry = {
    customerId: null
  };
  static recentTransactions = {
    customerId: null
  };
  static createPaymentIntent = {
    amount: "",
    customerId: ""
  };
  static read = {
    customerId: ""
  };

  static flutterwaveFunding = {
    customerId: null,
    amount: null,
    currency: null
  };
  static flutterwaveVerify = {
    id: null
  };
}

export default WalletRequest;
